<div class="menu-top-logo-layout" #popup>
  <button *ngIf="isAppListVisible" class="app-list-button" (click)="toggleContentVisibility()"
          aria-label="Apps">
    <svg width="30" height="30" viewBox="0 0 24 24" role="presentation">
      <path
        fill="currentcolor"
        fill-rule="evenodd"
        d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"
      ></path>
    </svg>
  </button>

  <!-- The panel sizes to its contents. 96% of people have one to three apps and 97.6% belong to one
       organisation, so a fixed width with a permanent organisation rail was mostly empty space. -->
  <div *ngIf="isPopupVisible" class="position-absolute launcher">

    <!-- The organisation rail, kept where it was. Each entry is a real button now, carries the full
         organisation name rather than only its initials, and announces which one is current. -->
    <nav class="org-rail" *ngIf="hasMultipleTenants" aria-label="Organisations">
      <ul class="list-unstyled">
        <li *ngFor="let orgName of tenantList">
          <button type="button"
                  [class.on]="orgName?.TenantId?.Id === railTenant"
                  [attr.aria-current]="orgName?.TenantId?.Id === railTenant ? 'true' : null"
                  [attr.title]="orgName?.TenantId?.OrganizationName"
                  [attr.aria-label]="orgName?.TenantId?.OrganizationName"
                  (click)="getAppListByTenant(orgName.TenantId.Id)">
            {{ orgInitials(orgName?.TenantId?.OrganizationName) }}
          </button>
        </li>
      </ul>
    </nav>

    <div class="launcher-body">
      <div class="launcher-head"><b>{{ railTenantName }}</b></div>

      <div *ngIf="isLoading" class="loader-container"><div class="loader-class"></div></div>

      <ng-container *ngIf="!isLoading">
      <!-- Only once there are enough tiles to lose one in. -->
      <div class="app-search" *ngIf="isSearchVisible">
        <input type="text" id="appLauncherSearch" [(ngModel)]="searchTerm"
               placeholder="Search apps" autocomplete="off" aria-label="Search apps" />
      </div>

      <!-- A heading earns its place only when there is a second section to tell it apart from. -->
      <h3 class="sect" *ngIf="filteredAppList.length && filteredExternalApps.length">Your apps</h3>

      <ul class="tiles list-unstyled" *ngIf="filteredAppList.length"
          [style.max-width.px]="tileRowWidth">
        <li *ngFor="let apps of filteredAppList">
          <button type="button" class="tile"
                  [class.selected]="selectedAppId === apps.AppId"
                  (click)="selectedApp(apps, selectedTenant)">
            <span class="thumb" *ngIf="apps.AppIcon">
              <img [src]="apps.AppIcon | AppIconUrlTransform | async" alt="" />
            </span>
            <!-- An app with no icon gets its own initial rather than the one generic picture every
                 app without an icon used to share, which made them indistinguishable. -->
            <span class="thumb mono" *ngIf="!apps.AppIcon"
                  [style.background]="monogramColour(apps.AppName)">{{ monogram(apps.AppName) }}</span>
            <span class="nm">{{ apps.AppName }}</span>
          </button>
        </li>
      </ul>

      <div *ngIf="!filteredAppList.length && !filteredExternalApps.length" class="nothing">
        {{ searchTerm ? 'No app matches that.' : 'No apps yet.' }}
      </div>

      <!-- A separate list with its own click handler, deliberately. The handler above packs the TAF
           session into the address it navigates to; that is right between TAF origins and nowhere
           else, so an outside app must not be able to reach it. Rendered as a real anchor so
           middle-click and assistive technology behave, with the opener severed. -->
      <ng-container *ngIf="filteredExternalApps.length">
        <h3 class="sect">External apps</h3>
        <ul class="tiles list-unstyled" [style.max-width.px]="tileRowWidth">
          <li *ngFor="let app of filteredExternalApps">
            <a class="tile" [href]="app.url" target="_blank" rel="noopener noreferrer"
               (click)="openExternalApp(app, $event)"
               [attr.title]="app.host ? app.name + ' - opens ' + app.host : app.name">
              <span class="thumb" *ngIf="app.iconUrl">
                <img [src]="app.iconUrl" alt="" (error)="app.iconUrl = null" />
                <span class="out" aria-hidden="true">&#8599;</span>
              </span>
              <span class="thumb mono" *ngIf="!app.iconUrl"
                    [style.background]="monogramColour(app.name)">{{ monogram(app.name) }}<span
                    class="out" aria-hidden="true">&#8599;</span></span>
              <span class="nm">{{ app.name }}</span>
              <!-- A host spelled with lookalike letters resolves somewhere else entirely; showing
                   the resolved name is what makes that visible. -->
              <span *ngIf="app.isPunycodeHost" class="lookalike">&#9888; {{ app.host }}</span>
            </a>
          </li>
        </ul>
      </ng-container>

      <button type="button" class="add-app" *ngIf="canShowCreateAppOption" (click)="addApp()">
        <i class="e-icons e-plus"></i> Add app
      </button>
      </ng-container>
    </div>
  </div>
</div>
